import { render, staticRenderFns } from "./ProjectGroupListing.vue?vue&type=template&id=8aed245c"
import script from "./ProjectGroupListing.vue?vue&type=script&lang=js"
export * from "./ProjectGroupListing.vue?vue&type=script&lang=js"
import style0 from "./ProjectGroupListing.vue?vue&type=style&index=0&id=8aed245c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports